import { render, staticRenderFns } from "./ShowcaseProducts.vue?vue&type=template&id=5639691e&scoped=true"
import script from "./ShowcaseProducts.vue?vue&type=script&lang=js"
export * from "./ShowcaseProducts.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseProducts.vue?vue&type=style&index=0&id=5639691e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639691e",
  null
  
)

export default component.exports